import { render, staticRenderFns } from "./RestrictionsCorpDetail.vue?vue&type=template&id=0f99d3fc"
import script from "./RestrictionsCorpDetail.vue?vue&type=script&lang=ts"
export * from "./RestrictionsCorpDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports